import { Component, OnInit } from '@angular/core';
import { Storage } from "@ionic/storage";
import { ManualPointService } from '../../services/manual-point.service';
import { ModalController, Platform } from "ionic-angular";
import { EmailDetailsComponent } from './email-details/email-details.component';
import { CommentsDetailsComponent } from './comments-details/comments-details.component';


declare let ga: any;

@Component({
  selector: 'reports',
  templateUrl: 'reports.html',

})
export class ReportsComponent {
  public saveOrEmail: string = "";
  public isPdfComponent: boolean = false;
  public access_token: string;
  public username: string;
  public path:string;
  constructor(
      private storage: Storage, 
      private manualPointService: ManualPointService,
      private modalCtrl: ModalController,
      private platform: Platform
    ) {}


    ngOnInit() {
      if (this.platform.is("mobileweb") || this.platform.is("core")) {
        this.access_token = sessionStorage.getItem('access_token');
        this.username = JSON.parse(sessionStorage.getItem('id_token_claims_obj')).globalid;
        this.username = this.username.replace("~AAD:","");
        ga('set', 'title', 'LogReports'); 
        ga('set', 'page', '/mobile/assets/logreport');
        ga('set', 'dimension1', this.username);
        ga('send', 'pageview');
      }
    }

  showEmailModal(e) {
    this.isPdfComponent = true;
    let modal = this.modalCtrl.create(EmailDetailsComponent, {
      //pdfData: base64,
      filePath:this.path
    })
    modal.present();
  }

  // downloadPdf() {
  //   this.saveOrEmail = "save";
  //   this.isPdfComponent = true;
  // }

  emailPdfEvent($event) {
    this.saveOrEmail = "email";
    this.isPdfComponent = true;
    this.path=$event;
  }

  removePdfComponent($event) {
    this.isPdfComponent = true;
    let modal = this.modalCtrl.create(CommentsDetailsComponent, {
     // pdfData: base64
    })
    modal.present();
  }
  sendPdfData($event){
    
  }  

}



// WEBPACK FOOTER //
// ./src/components/reports/reports.ts